import React from 'react'

import FormManager from "../../../gd-form/common/form-manager"
import FormRowFlex from "../../../gd-form/form/form-flex/row"
import FieldFormElement from "../../../fields3/render/form-elemnent"
import FormError from "../../../gd-form/common/form-error/form-error"

type Props = {
    form: FormManager
}

export default function CustomFieldSymbol(props: Props) {

    const field = gd.fields.customFieldParams.symbol

    return (
        <FormRowFlex field={field}>
            <FieldFormElement className = "w-300"
                              field     = {field}
                              form      = {props.form}/>
            <FormError form = {props.form}
                       name = {field.fieldId} />
        </FormRowFlex>
    )
}